module.exports = "pegasus/assets/styleGroup1-youtube.gif";